module.exports = {
  'en': {
    'HRES80XP1': {
      '10': 'History of illness(1)',
      '20': 'Code Employee',
      '30': 'No.',
      '40': 'Detail',
      '50': 'Without/',
      '60': 'Never',
      '70': 'Have/',
      '80': 'Ever',
      '90': 'Remark ',
      '100': '1',
      '110': '2',
      '120': '3',
      '130': '4',
      '140': '5',
      '150': '6',
      '160': '7',
      '170': '8',
      '180': '9',
      '190': 'Persistent or chronic disease or not',
      '200': 'I had the surgery or not',
      '210': 'Been immune to the disease',
      '215': 'Or to prevent disease or not',
      '220': 'Family history of illness of this ruling',
      '225': 'as cancer,diabetes,anemia,tuberculosis,asthma,allergies,etc.',
      '230': 'There are medications that need to eat regularly or not',
      '240': 'The medical history or not',
      '250': 'To drug or any drug or not',
      '260': 'I used to smoke or not',
      '270': 'Never',
      '280': 'Ever and current smoking in the volume',
      '290': 'Cigarettes / day',
      '300': 'But never quit. How long does it ever',
      '310': 'Year',
      '320': 'Month',
      '330': 'At the first stop',
      '340': 'Cigarettes / day',
      '350': 'Been drinking beer or drinking alcohol or not',
      '360': 'Never',
      '370': 'Typically less than 1 drink per week',
      '380': '1 drink per week',
      '390': 'Drink 2-3 times a week',
      '400': 'Drinking more than three times a week',
      '410': 'To illness or injury',
      '420': 'Year',
      '430': 'Month'
    },
    'HRES80XP2': {
      '10': 'History of illness(2)',
      '20': 'But never quit. Transfer time is long',
      '30': 'Seq.',
      '40': 'Detail',
      '50': 'On year'
    },
    'HRES80XP3': {
      '10': 'Family history of illness',
      '20': 'History of illness of family members',
      '25': 'Such cancer, anemia, tuberculosis, diabetes, allergies, etc.',
      '30': 'Seq.',
      '40': 'Relationship',
      '50': 'Sickness'
    },
    'HRES80XP4': {
      '10': 'Other',
      '20': 'Other health information helpful'
    },
    'HRES80XP5': {
      '10': 'Medical history',
      '20': 'For year',
      '30': 'Checklist',
      '40': 'Program',
      '50': 'Values??',
      '60': 'Results',
      '70': 'This year',
      '80': 'Comment of medical opinions',
      '90': 'Date'
    }
  },
  'th': {
    'HRES80XP1': {
      '10': 'ประวัติการเจ็บป่วย(1)',
      '20': 'รหัสพนักงาน',
      '30': 'ข้อที่',
      '40': 'รายละเอียด',
      '50': 'ไม่มี/',
      '60': 'ไม่เคย',
      '70': 'มี/',
      '80': 'เคย',
      '90': 'ระบุ',
      '100': '1',
      '110': '2',
      '120': '3',
      '130': '4',
      '140': '5',
      '150': '6',
      '160': '7',
      '170': '8',
      '180': '9',
      '190': 'มีโรคประจำตัวหรือโรคเรื้อรังหรือไม่',
      '200': 'เคยได้รับการผ่าตัดหรือไม่',
      '210': 'เคยได้รับภูมิคุ้มกันโรคกรณีเกิดโรคระบาด ',
      '215': 'หรือ เพื่อป้องกันโรคติดต่อหรือไม่',
      '220': 'ประวัติการเจ็บป่วยของสมาชิกในาครอบครัว',
      '225': 'เช่น มะเร็ง โลหิตจาง วัณโรค เบาหวาน หอบหืด ภูมิแพ้ เป็นต้น',
      '230': 'ปัจจุบันมียาที่จำเป็นต้องรับประทานเป็นประจำหรือไม่',
      '240': 'มีประวัติการแพ้ยาหรือไม่',
      '250': 'เคยเสพยาเสพติดหรือสารเสพติดใดๆบ้างหรือไม่',
      '260': 'เคยสูบบุหรี่บ้างหรือไม่',
      '270': 'ไม่เคย',
      '280': 'เคยและปัจจุบันยังสูบอยู่ปริมาณ',
      '290': 'มวน/วัน',
      '300': 'เคยแต่เลิกแล้ว ระยะเวลาที่เคยสูบนาน',
      '310': 'ปี',
      '320': 'เดือน',
      '330': 'ปริมาณขณะก่อนเลิก',
      '340': 'มวน/วัน',
      '350': 'เคยดื่มสุรา เบียร์ หรือเครื่องดืมแอลกอฮอล์หรือไม่',
      '360': 'ไม่เคย',
      '370': 'โดยปกติดื่มน้อยกว่า 1 ครั้งต่อสัปดาห์',
      '380': 'ดื่ม 1 ครั้งต่อสัปดาห์',
      '390': 'ดื่ม 2-3  ครั้งต่อสัปดาห์',
      '400': 'ดื่มมากกว่า 3 ครั้งต่อสัปดาห์',
      '410': 'เคยแต่เลิกแล้ว ระยเวลาที่ดื่มนาน ',
      '420': 'ปี',
      '430': 'เดือน'
    },
    'HRES80XP2': {
      '10': 'ประวัติการเจ็บป่วย(2)',
      '20': 'เคยป่วยเป็นโรคหรือมีการบาดเจ็บ',
      '30': 'ลำดับที่',
      '40': 'รายละเอียด',
      '50': 'เมื่อปี พ.ศ.'
    },
    'HRES80XP3': {
      '10': 'ประวัติการเจ็บป่วยของครอบครัว',
      '20': 'ประวัติการเจ็บป่วยของสมาชิกในครอบครัว',
      '25': '(เช่น มะเร็ง โลหิตจาง วัณโรค เบาหวาน ภูมิแพ้ เป็นต้น)',
      '30': 'ลำดับที่',
      '40': 'ความสัมพันธ์',
      '50': 'โรค'
    },
    'HRES80XP4': {
      '10': 'ข้อมูลอื่นๆ',
      '20': 'ข้อมูลสุขภาพอื่นๆที่เป็นประโยชน์'
    },
    'HRES80XP5': {
      '10': 'ประวัติการตรวจสุขภาพ',
      '20': 'สำหรับปี',
      '30': 'รายการตรวจ',
      '40': 'โปรแกรม',
      '50': 'ค่าที่ได้',
      '60': 'ผลตรวจ',
      '70': 'ประจำปี',
      '80': 'สรุปความคิดเห็นแพทย์',
      '90': 'วันที่'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres80x.js